
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.375 20.25a.796.796 0 01-.13-.011 1.126 1.126 0 01-.983-.983.808.808 0 010-.262c.06-.513.47-.923.983-.983a.796.796 0 01.261 0c.513.06.923.47.983.983a.808.808 0 010 .262c-.06.513-.47.923-.983.983a.817.817 0 01-.131.011zM4.125 20.25a.796.796 0 01-.13-.011 1.127 1.127 0 01-.983-.982.737.737 0 01-.001-.263c.06-.513.47-.922.983-.983a.817.817 0 01.261 0c.513.061.922.47.983.983a.717.717 0 01.001.262c-.06.513-.47.922-.983.983a.817.817 0 01-.131.011z"}}),_c('path',{attrs:{"d":"M15.375 23.25a4.14 4.14 0 01-3.969-3H8.094a4.14 4.14 0 01-3.969 3C1.85 23.25 0 21.399 0 19.125S1.85 15 4.125 15a4.13 4.13 0 014.108 3.75h3.034a4.068 4.068 0 01.93-2.25H9.75a.747.747 0 01-.671-.414L7.786 13.5H.75a.75.75 0 010-1.5h.75V5.25H.75A.75.75 0 010 4.5v-2C0 1.535.785.75 1.75.75h8.5c.965 0 1.75.785 1.75 1.75v2a.75.75 0 01-.75.75h-.177l-2.024 7.421L10.214 15h2.536v-1.5c0-.161.053-.321.15-.45l1.8-2.4a2.26 2.26 0 011.8-.9h5.25A2.252 2.252 0 0124 12v6a2.252 2.252 0 01-2.25 2.25h-2.406a4.14 4.14 0 01-3.969 3zm0-6.75c-1.448 0-2.625 1.177-2.625 2.625s1.177 2.625 2.625 2.625S18 20.573 18 19.125 16.823 16.5 15.375 16.5zm-11.25 0c-1.447 0-2.625 1.177-2.625 2.625s1.178 2.625 2.625 2.625 2.625-1.177 2.625-2.625S5.572 16.5 4.125 16.5zm17.625 2.25a.75.75 0 00.75-.75v-6a.75.75 0 00-.75-.75H16.5a.753.753 0 00-.6.3l-1.65 2.2v1.407a4.13 4.13 0 015.233 3.593h2.267zM7.677 12l1.841-6.75H3V12h4.677zM10.5 3.75V2.5a.25.25 0 00-.25-.25h-8.5a.25.25 0 00-.25.25v1.25h9z"}})])
          )
        }
      }
    